import { getAppApiRoutes } from "../../Global";
import { DeviceFilterRequestModel } from "../../models/RequestModels";
import ResponseModel from "../../models/ResponseModel";
import { apiPost } from "../apiClient";

class DeviceService {
  async getDevices(filter: DeviceFilterRequestModel = {}): Promise<ResponseModel> {
    return apiPost(getAppApiRoutes.device.getDevices, { filter });
  }

  async deviceTakeBack(id: number): Promise<ResponseModel> {
    return apiPost(getAppApiRoutes.device.deviceTakeBack.replace("{id}", id.toString()), {});
  }

  async deviceRelocation(id: number): Promise<ResponseModel> {
    return apiPost(getAppApiRoutes.device.deviceRelocation.replace("{id}", id.toString()), {});
  }

  async deviceReplacement(id: number): Promise<ResponseModel> {
    return apiPost(getAppApiRoutes.device.deviceReplacement.replace("{id}", id.toString()), {});
  }
}

const service: DeviceService = new DeviceService();
export default service;
